import common from './common.json'
import landing from './landing.json'
import auth from './auth.json'
import app from './app.json'

export default { common, landing, auth, app }
